import { useSearchParams, Link, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const GuidelineListingPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">出品ガイドライン</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">出品条件</div>
            </div>
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-base font-normal leading-7">各カテゴリの出品条件、クオリティガイドラインは以下のページをご確認ください。</div>
              <div className="inline-flex justify-start items-start gap-2.5">
                <Link to={`/terms/quality_guideline_non_psa${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">シングルカード</Link>
                <div className="justify-center text-black text-base font-normal leading-7">/</div>
                <Link to={`/terms/quality_guideline_box${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">未開封ボックス</Link>
                <div className="justify-center text-black text-base font-normal leading-7">/</div>
                <Link to={`/terms/quality_guideline_psa${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">PSA</Link>
                <div className="justify-center text-black text-base font-normal leading-7">/</div>
                <Link to={`/terms/quality_guideline_unopened_card${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">未開封カード</Link>
                <div className="justify-center text-black text-base font-normal leading-7">/</div>
                <Link to={`/terms/quality_guideline_unopened_pack${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">未開封パック</Link>
                <div className="justify-center text-black text-base font-normal leading-7">/</div>
                <Link to={`/terms/quality_guideline_figure_hobby${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">フィギュア・ホビー</Link>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">出品禁止品</div>
            </div>
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center">
                <span className="text-black text-base font-normal leading-7">以下の項目に該当する場合、出品することはできません。<br/>・DONDONに商品登録がされていないもの<br/>・偽造品の疑いがある商品<br/>・シュリンクが付いていないボックス<br/>・ノベルティ・サンプル品などの非売品<br/>・汚れ・変色・変形などのダメージが見られる商品<br/>・ボックスの破損などにより、カード本体へ影響が及んでいる可能性がある商品<br/>・開封の痕跡や、シュリンクの破れが確認される商品<br/>・付属品の一部が欠けている商品<br/>・直筆サインや直筆イラストが含まれる商品<br/>・破れ、深い折れ、水濡れ、書き込みなどが見られる商品<br/>・シール、ショップバッグ、ショップステッカー　※付属品としての出品も不可<br/>・商標権・著作権など知的財産権を侵害するおそれのあるカスタム品<br/>・害虫やカビによる汚損が確認される商品</span>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">出品情報について</div>
            </div>
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center">
                <span className="text-black text-base font-normal leading-7">商品の種類や状態など、出品情報は正確にご入力ください。<br/>なお、検品の際には、商品状態がガイドラインに定められた基準と一致しているかを確認しています。商品説明やコメントに記載された内容よりも、ガイドラインの基準が優先されますのでご注意ください。<br/>※また、商品状態に関わらず、購入者様に誤解を与えるような表現や、出品情報と大きく異なる内容が記載されている場合には、取引がキャンセルとなることがあります。</span>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">取引成立後の発送について</div>
            </div>
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center">
                <span className="text-black text-base font-normal leading-7">複数商品を同梱して発送される場合は、必ず取引ごとに商品をブロックごとに分け、それぞれのブロックに対応する取引IDがわかる付箋などを同梱してください。<br/>梱包方法に不備があると、商品の特性や取引上の都合により、取引キャンセルの原因となる可能性があります。</span>
              </div>
              <div className="flex flex-col justify-start items-start">
                <div className="justify-center text-black text-base font-normal leading-7">あわせて、以下のページも必ずご確認ください。</div>
                <Link to={`/terms/guideline_packing_shipping${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">梱包・発送のガイドライン</Link>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">異物混入時の対応</div>
            </div>
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-base font-normal leading-7">商品に異物が混入していた場合は、鑑定結果に関わらず取引をキャンセルし、商品は出品者様へ返送させていただきます。</div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">鑑定・検品時にガイドラインの基準を満たしていないと判断された場合</div>
            </div>
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center">
                <span className="text-black text-base font-normal leading-7">鑑定や検品の結果、ガイドラインの基準を満たしていないと判断された場合は、購入者様に取引を継続するかどうかのご確認をさせていただきます。<br/>取引がキャンセルとなった際は、商品は着払い（配送料は出品者様ご負担）にて返送いたします。</span>
              </div>
              <div className="justify-center">
                <span className="text-black text-base font-normal leading-7">・商品の検品時には、出品時に選択された商品状態がガイドラインに定められた基準と一致しているかを確認しています。<br/>・なお、補足説明に記載された内容よりも、ガイドラインの基準が優先されます。<br/></span>
                <span className="text-black text-base font-normal leading-7">※作業の過程で廃棄された梱包資材や鑑定証明物などはご返却できません。あわせて、これらに関する補償も承っておりませんのでご了承ください。</span>
              </div>
              <div className="justify-center">
                <span className="text-black text-base font-normal leading-7">なお、下記に該当する商品については、事務局の判断により取引をキャンセルさせていただく場合がございます。<br/>その際も、商品は着払い（配送料出品者様ご負担）での返送となります。<br/>・ガイドラインの基準を明らかに満たしていない場合<br/>・出品画像と実際の商品が異なる場合<br/>・出品が禁止されている商品である場合<br/>・商品に異物が混入している場合</span>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">付属品に関する注意事項</div>
            </div>
            <div className="justify-center">
              <span className="text-black text-base font-normal leading-7">付属品と判断されるものは、検品の工程で破棄いたします。<br/>【例】<br/>・DONDONの鑑定済みシール<br/>・他社鑑定機関の鑑定済シール、証明書、納品書 等<br/>・シール、ショップバッグ、ショップステッカー 等</span>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">迷惑行為・禁止行為</div>
            </div>
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center">
                <span className="text-black text-base font-normal leading-7">DONDONでは、偽造品の流通を防止するため、厳格な取り組みを行っています。<br/>偽造品であることを認識したうえでの出品と判断される場合や、過去に偽造品と鑑定された商品・出品禁止とされた商品の再出品など、悪質性の高い行為については、違反金として商品価格の50%をご請求いたします。<br/>また、中古商品ページと異なる内容での出品など、他のお客様のご利用を妨げる行為は迷惑行為とみなされ、<br/>問題が確認された際には、該当商品の出品削除やアカウントの利用制限などの措置を行う場合がございます。</span>
              </div>
              <div className="flex flex-col justify-start items-start">
                <div className="justify-center text-black text-base font-normal leading-7">詳細につきましては、以下のページをご確認ください。</div>
                <Link to={`/terms/spam_behavior${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">迷惑行為について</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default GuidelineListingPage;
